<script setup>
import { ref, watch } from 'vue';
import Dropdown from 'primevue/dropdown';

const { typeFormat, typesFormatProposes } = defineProps({
    typeFormat: Object,
    typesFormatProposes: Array
});

const emit = defineEmits(['update:typeFormat', 'modification']);

const typeFormatSelectionne = ref(typeFormat);

watch(() => typeFormat, (t) => {
    typeFormatSelectionne.value = t;
});

function modifierTypeFormat(t) {
    if (t !== typeFormat) {
        emit('modification', t);
    }
}

</script>

<template>
    <Dropdown 
      v-model="typeFormatSelectionne" 
      :options="typesFormatProposes" 
      optionLabel="libelle"
      placeholder="Valeur brute"
      :showClear="true"
      @change="modifierTypeFormat($event.value)" />
</template>

<style scoped>

</style>